module.exports = __webpack_public_path__ + "img/wb_o_office-roscommon.f30998fc.svg";